@use "../../../../../../../sedestral/sass/mixins/texts";

.componentOfferCreditsModal {
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .section {
    margin-bottom: 20px;

    .sectionTitle {
      font-size: 15px;
      margin-bottom: 10px;
      border-top: 1px solid var(--grey-sur);
      margin-top: 10px;
      padding-top: 10px;

      @include texts.font("semi-bold");
    }

    .amountSelector {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;

      .amountPresets {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .preset {
          padding: 10px 20px;
          border: 1px solid var(--grey-sur);
          border-radius: 30px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.15s;

          @include texts.font("semi-bold");

          &:hover {
            border-color: var(--grey-sur-hover);
            background: var(--grey-sur);
          }

          &.active {
            background: var(--black);
            color: var(--white);
            border-color: var(--black);
          }
        }
      }

      .customAmountContainer {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
        gap: 6px;

        .customAmountInput {
          width: 100%;
          padding: 10px 14px;
          border: 1px solid var(--grey-sur);
          border-radius: 30px;
          font-size: 14px;
          outline: none;
          transition: border-color 0.15s;
          background: transparent;
          color: var(--black);

          &:focus {
            border-color: var(--black);
          }

          &::placeholder {
            color: var(--grey-text);
          }
        }

        .customAmountCurrency {
          font-size: 17px;
          color: var(--black);
        }
      }
    }

    .addressContainer {
      margin-top: 5px;
    }

    .stripeContainer {
      min-height: 50px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      > * {
        width: 100%;
      }
    }
  }

  .cgvSection {
    font-size: 14px;
    margin-bottom: 10px;
    margin-top: 25px;
    display: flex;

    span {
      margin-left: 10px;
    }
  }

  .errorZone {

    .error {
      color: var(--red);
      font-size: 13px;
      margin-bottom: 10px;
      padding: 8px 12px;
      background: rgba(239, 68, 68, 0.1);
      border-radius: 8px;
    }
  }

  .recap {
    border: 1px solid var(--grey-sur);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 20px;
    margin-top: 15px;

    .recapTitle {
      font-size: 15px;
      margin-bottom: 12px;

      @include texts.font("semi-bold");
    }

    .recapRow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      padding: 6px 0;
      color: var(--grey-text-very-dark);

      &.recapTotal {
        border-top: 1px solid var(--grey-sur);
        margin-top: 8px;
        padding-top: 12px;
        color: var(--black);

        @include texts.font("semi-bold");
      }
    }

    .recapInvoice {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid var(--grey-sur);
      display: flex;
      justify-content: center;

      .invoiceLink {
        font-size: 13px;
        color: var(--blue);
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;

    .continueButton, .payButton {
      padding: 14px 28px;
      font-size: 15px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      width: fit-content;
      background: var(--black);
      border-radius: 30px;
      color: var(--white);
      min-width: 150px;

      @include texts.font("semi-bold");

      &:hover {
        opacity: 0.8;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .section {
      .amountSelector {
        flex-wrap: wrap;

        .amountPresets {
          flex-wrap: wrap;
        }

        .customAmountContainer {
          flex-basis: 100%;
        }
      }
    }

    .footer {
      .continueButton, .payButton {
        width: 100%;
        box-sizing: border-box;
      }
    }

    .confirmationActions {
      flex-direction: column;
      width: 100%;

      .downloadButton, .closeButton {
        text-align: center;
      }
    }
  }

  .confirmationStep {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    text-align: center;

    .confirmationTitle {
      font-size: 18px;
      margin-bottom: 12px;

      @include texts.font("semi-bold");
    }

    .confirmationMessage {
      font-size: 14px;
      color: var(--grey-text);
      margin-bottom: 16px;
    }

    .confirmationLoader {
      margin-bottom: 16px;
      height: 50px;
      width: 50px;
      position: relative;
    }

    .confirmationActions {
      display: flex;
      gap: 10px;

      .downloadButton {
        padding: 12px 24px;
        font-size: 14px;
        cursor: pointer;
        background: var(--black);
        border-radius: 30px;
        color: var(--white);

        @include texts.font("semi-bold");

        &:hover {
          opacity: 0.8;
        }
      }

      .closeButton {
        padding: 12px 24px;
        font-size: 14px;
        cursor: pointer;
        border: 1px solid var(--grey-sur);
        border-radius: 30px;
        color: var(--black);

        @include texts.font("semi-bold");

        &:hover {
          background: var(--grey-sur);
        }
      }
    }
  }
}
